module.exports = __webpack_public_path__ + "static/media/restaurant7.ce0831bb.jpg";